var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn-group',{staticClass:"q-mx-sm",attrs:{"flat":""}},_vm._l((_vm.indicators),function(ref){
var name = ref.name;
var label = ref.label;
var icon = ref.icon;
return _c('q-btn',{key:("indicator-" + name),attrs:{"dense":"","text-color":"grey-7"},on:{"click":function($event){return _vm.$emit('click', name)}}},[_c('q-icon',{attrs:{"name":icon,"size":"1rem"}}),_c('q-badge',{attrs:{"color":"white","text-color":"primary"}},[_c('strong',[_vm._v(_vm._s(_vm.counts ? _vm.counts[name] : 0))])])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }